import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AuthenticationStore } from '../../permission/services/authentication.store';

@Component({
  selector: 'pioneer-expiration-modal',
  templateUrl: `./expiration-modal.component.html`,
  styleUrls: [ './expiration-modal.component.css' ]
})
export class ExpirationModalComponent implements OnInit {

  @ViewChild(ModalDirective)
  public expirationModal: ModalDirective;

  @Input()
  public logOutEarly = 'AUTHENTICATION_EXPIRATION.LOG_OUT_EARLY';

  @Input()
  public stayLoggedIn = 'AUTHENTICATION_EXPIRATION.STAY_LOGGED_IN';

  @Input()
  public returnToLogin = 'AUTHENTICATION_EXPIRATION.RETURN_TO_LOGIN';

  @Input()
  public title = 'AUTHENTICATION_EXPIRATION.TITLE';

  @Input()
  public content = 'AUTHENTICATION_EXPIRATION.CONTENT_NOT_EXPIRED';

  @Input()
  public config = {
    backdrop: 'static',
    keyboard: false
  };

  @Output()
  public closed = new EventEmitter();

  private expiredAlready = false;

  get alreadyExpired(): boolean {
    return this.expiredAlready;
  }

  setAlreadyExpired(expired: boolean) {
    this.expiredAlready = expired;
  }

  constructor(private authenticationStore: AuthenticationStore) {
  }

  ngOnInit() {
  }

  public open(): void {
    this.expirationModal.show();
  }

  public close(value: boolean): void {
    this.closed.emit(value);
    this.expirationModal.hide();
  }

  public endSession(): void {
    this.authenticationStore.logout();
    this.close(false);
  }

  public refreshAuthentication(): void {
    this.authenticationStore.refreshAuthentication().subscribe(() => {
      this.close(true);
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/expiration-modal/expiration-modal.component.ts